import {BaseResponseDTO} from "./base.response.dto";
import {JornadaDTO} from "../jornada.dto";


export class GetListaJorndasResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: {
    hasNext: boolean;
    hasPrev: boolean;
    pageIndex: number;
    pageSize: number;
    totalPageCount: number;
    totalRowCount: number;
    list: Array<JornadaDTO>;
  }

}
